<template>
    <div class="wrapper">
        <friends-list/>
    </div>
</template>
<script>
import FriendsList from '@/pages/message/FriendsList.vue'
export default {
    name:'mypage_friends',
    data()
    {
        return{

        }
    },
    components:{
        FriendsList    
    }

}
</script>
<style lang="scss" scoped>
.wrapper{
    padding:0 20px;
}
</style>
